import User from "./User.js";

/**
 * Sub class of user.
 *
 * @param {string} spec.agencyId - Agency id of the agency to which
 *   the user belongs
 * @param {string[]} spec.companyIds - List of customers the agency
 *   user manages
 * @param {string} [spec.officeAffiliation] - User's workplace
 */
export default class AgencyUser extends User {
	constructor({ agencyId, companyIds, officeAffiliation = "" } = {}) {
		super(...arguments);

		this._agencyId = agencyId;
		this._companyIds = new Set(companyIds);
		this._officeAffiliation = officeAffiliation;
	}

	canBeNotifiedFor() {
		return true;
	}

	isAgencyUser() {
		return true;
	}

	getAgencyId() {
		return this._agencyId;
	}

	getNumberOfCompanies() {
		return this._companyIds.size;
	}

	addCompany(company) {
		this._companyIds.add(company.getLegacyId());
	}

	removeCompany(company) {
		this._companyIds.delete(company.getLegacyId());
	}

	getCompanyIds() {
		return [...this._companyIds];
	}

	hasCompanyRole() {
		return true;
	}

	getOfficeAffiliation() {
		return this._officeAffiliation;
	}

	canSendPeriodNotifications() {
		return true;
	}

	canEditLiquidityReport() {
		return true;
	}

	canSeePeriodReportViewers() {
		return !this.isTemporaryUser();
	}

	canViewWithdrawnPeriodReports() {
		return true;
	}

	canRegisterViewEventForReport() {
		return true;
	}

	_defaultAvatarUrl() {
		return "/Client/img/avatar-consultant-grey-lg@2x.png";
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.companyIds = [...this._companyIds];

		return schema;
	}
}
